module.exports = __webpack_public_path__ + "img/india.1a063a43.jpg";